import { Injectable } from '@angular/core';
import { JsonService }  from '../../services/json/json.service';
import { Http } from '@angular/http';
import { Response } from '@angular/http';

@Injectable()
export class ReactiveformService extends JsonService {

  public justCreated: boolean = false;
  public title: string;
  public backLink: string = '/';

  constructor(public http: Http) {
    super(http);
  }
}
